import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import cognitoAuth from "../../util/Cognito";
import "./ChangePasswordDialog.css";

export default function ChangePasswordDialog(props) {
  const [showSecondModal, setShowSecondModal] = useState(false);
  const handleCloseModal = () => {
    setShowSecondModal(false);
  };
  const changePassword = () => {
    let oldPass = document.getElementById("oldPass").value;
    let newPass = document.getElementById("newPass").value;
    let confirmPass = document.getElementById("confirmPass").value;
    cognitoAuth
      .changePassword(oldPass, newPass, confirmPass)
      .then(() => {
        setShowSecondModal(true);
        props.handleClose();
      })
      .catch((e) => {
        document
          .getElementById("ceChangePassword")
          .getElementsByClassName("errMsg")[0].style.visibility = "visible";
        if (e.errCode > 10000) {
          let id = "errCode_" + e.errCode;
          document
            .getElementById("ceChangePassword")
            .getElementsByClassName("errMsg")[0].innerHTML =
            props.intl.formatMessage({ id: id });
        }
      });
  };

  return (
    <>
      <Modal
        id="ceChangePassword"
        show={props.show}
        onHide={props.handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {
              <div className="content-title">
                <span>
                  {props.intl.formatMessage({ id: "header_change_password" })}
                </span>
              </div>
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>
            {props.intl.formatMessage({ id: "header_password_explanation" })}
          </span>
          <div className="label mgT">
            <span>
              {props.intl.formatMessage({ id: "header_old_password" })}
            </span>
          </div>
          <div className="inputField password">
            <input
              id="oldPass"
              type="password"
              name="pass"
              size="30"
              maxLength="40"
            />
          </div>
          <div className="label mgT">
            <span>
              {props.intl.formatMessage({ id: "header_new_password" })}
            </span>
          </div>
          <div className="inputField password">
            <input
              id="newPass"
              type="password"
              name="pass"
              size="30"
              maxLength="40"
            />
          </div>
          <div className="label mgT">
            <span>
              {props.intl.formatMessage({ id: "header_confirm_password" })}
            </span>
          </div>
          <div className="inputField password">
            <input
              id="confirmPass"
              type="password"
              name="pass"
              size="30"
              maxLength="40"
            />
          </div>
          <div className="errMsg">
            {<span>{props.intl.formatMessage({ id: "errCode_10000" })}</span>}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={changePassword.bind(this, props)}>
            {props.intl.formatMessage({ id: "header_apply" })}
          </Button>
          <Button variant="secondary" onClick={props.handleClose}>
            {props.intl.formatMessage({ id: "header_cancel" })}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSecondModal}
        onHide={() => handleCloseModal()}
        size="sm"
        centered
        backdrop="static"
      >
        <Modal.Body>
          <span className="confirmDialog">
            {props.intl.formatMessage({
              id: "password_change_complete",
            })}
          </span>
        </Modal.Body>
        <Modal.Footer>
          <Button
            class="btn btn-primary"
            variant="primary"
            onClick={() => handleCloseModal()}
          >
            {props.intl.formatMessage({ id: "header_ok" })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
